import utils from '@/util'
import {
  isBlockExist, defaultHeadingText, hasTag, generateBlockId,
  generateBlockHash,
} from './common'

const titleAndBobyLayoutThumbnail = require('@/assets/images/content-slide-layouts/layout_title_body.svg')

const defaultHeadingStyle = {
  width: '1200px',
  height: '90px',
  transform: 'translate(30px, 20px)',
}
const defaultContentStyle = {
  width: '1200px',
  height: '465px',
  transform: 'translate(30px, 120px)',
}

const headingContent = (headingText) => {
  return {
    value: `
    <p style="text-align: left;" data-mce-style="text-align: left;">
      <span style="font-size: 48px;" data-mce-style="font-size: 48px;">
        <strong>
          ${headingText}
        </strong>
      </span>
    </p>
    `,
  }
}

const bodyContent = (bodyText) => {
  return {
    value: `
      <p style="text-align: left;" data-mce-style="text-align: left;">
        ${bodyText}
      </p>
    `,
  }
}

function layoutBuilder(slideId, currentCanvasBlocks) {
  const newCanvasBlocks = { ...currentCanvasBlocks }

  if (!isBlockExist(currentCanvasBlocks, hasTag('heading'))) {
    const blockId = generateBlockId(slideId)
    newCanvasBlocks[blockId] = {
      id: blockId,
      type: 'RichText',
      tag: 'heading',
      content: headingContent(defaultHeadingText),
      style: defaultHeadingStyle,
      h: generateBlockHash(),
    }
  }
  if (!isBlockExist(currentCanvasBlocks, hasTag('content'))) {
    const blockId = generateBlockId(slideId)
    newCanvasBlocks[blockId] = {
      id: blockId,
      type: 'RichText',
      tag: 'content',
      content: bodyContent('Click to add content'),
      style: defaultContentStyle,
      h: generateBlockHash(),
    }
  }

  if (currentCanvasBlocks) {
    Object.keys(currentCanvasBlocks).forEach((blockId) => {
      const block = currentCanvasBlocks[blockId]
      if (block.tag === 'heading') {
        const newBlock = {
          ...block,
          id: generateBlockId(slideId),
          style: defaultHeadingStyle,
          hidden: false,
          content: headingContent(utils.extractContent(block.content.value, true) || defaultHeadingText),
          h: generateBlockHash(),
        }
        newCanvasBlocks[newBlock.id] = newBlock
        delete newCanvasBlocks[blockId]
      } else if (block.tag === 'content') {
        const newBlock = {
          ...block,
          id: generateBlockId(slideId),
          style: defaultContentStyle,
          hidden: false,
          content: bodyContent(utils.extractContent(block.content.value, true) || 'Click to add content'),
          h: generateBlockHash(),
        }
        newCanvasBlocks[newBlock.id] = newBlock
        delete newCanvasBlocks[blockId]
      } else {
        newCanvasBlocks[blockId] = {
          ...block,
          hidden: true,
        }
      }
    })
  }

  return newCanvasBlocks
}

const HeadingAndBodyLayout = {
  type: 'default',
  name: 'Title and Body',
  layoutThumbnailImage: titleAndBobyLayoutThumbnail,
  build: layoutBuilder,
}

export default HeadingAndBodyLayout
